export const environment = {
  production: true,
  buildId: '3318177781621581',
  configFile: 'config.json',
};
